import React from "react";
import { NavLink } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import styles from "./Footer.module.css";

const Footer = ({ hideWave, className }) => {
  const footerClassName = className
    ? `${styles.footer__section} ${className}`
    : styles.aboutFooter;

  const handleLinkClick = () => {
    scroll.scrollToTop();
  };

  return (
    <div id="contact" className={styles.footer__container}>
      {!hideWave && (
        <div className={styles.waves}>
          <div className={styles.wave} id={styles.wave1}></div>
          <div className={styles.wave} id={styles.wave2}></div>
          <div className={styles.wave} id={styles.wave3}></div>
          <div className={styles.wave} id={styles.wave4}></div>
        </div>
      )}
      <div className={footerClassName}>
        <div className={styles.footer__links}>
          <div className={styles.footer__links__div}>
            <h4>About the Project</h4>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/aov"
                onClick={handleLinkClick}
              >
                Aim
              </NavLink>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/aov"
                onClick={handleLinkClick}
              >
                Ojective
              </NavLink>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/aov"
                onClick={handleLinkClick}
              >
                Vision
              </NavLink>
            </p>
          </div>
          <div className={styles.footer__links__div}>
            <h4>Services</h4>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/schedule"
                onClick={handleLinkClick}
              >
                Individual Schedule
              </NavLink>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/schedule"
                onClick={handleLinkClick}
              >
                Team Schedule
              </NavLink>
            </p>
          </div>
          <div className={styles.footer__links__div}>
            <h4>Pricing</h4>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/pricing"
                onClick={handleLinkClick}
              >
                Individual
              </NavLink>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/pricing"
                onClick={handleLinkClick}
              >
                Team
              </NavLink>
            </p>
          </div>
          <div className={styles.footer__links__div}>
            <h4>Contact Me</h4>
            <p>
              <a
                className={styles.anchorLink}
                href="mailto:babatundetaiwo038@gmail.com"
              >
                babatundetaiwo038@gmail.com
              </a>
            </p>
            <p>
              <a className={styles.anchorLink} href="https://www.babatundetaiwo.com/">
                Developed by Babatunde
              </a>
            </p>
            <p>
              <a
                className={styles.anchorLink}
                href="https://www.linkedin.com/in/babatunde-yusuf-taiwo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn Profile
              </a>
            </p>
          </div>
          <div className={styles.footer__links__div}>
            <h4>Socials</h4>
            <div className={styles.footer__socialmedia}>
              <p>
                <a
                  href="https://twitter.com/CalMiBabs_"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-twitter"></i>
                </a>
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/babatunde-yusuf-taiwo/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-linkedin-in"></i>
                </a>
              </p>
              <p>
                <a
                  href="https://github.com/Proac-Tee"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-github"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div className={styles.footer__below}>
          <div className={styles.footer__copyright}>
            <p>
              &copy; {new Date().getFullYear()} Babatunde Taiwo. All rights
              reserved.
            </p>
          </div>
          <div className={styles.footer__below_links}>
            <p>
              <a
                href="https://www.freepik.com/free-vector/appointment-booking-with-calendar_8398821.htm#query=someone%20scheduling&position=21&from_view=search&track=ais"
                className={styles.anchorLink}
              >
                Image by Freepik
              </a>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/disclaimer"
                onClick={handleLinkClick}
              >
                Terms &amp; Conditions
              </NavLink>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/disclaimer"
                onClick={handleLinkClick}
              >
                Privacy
              </NavLink>
            </p>
            <p>
              <NavLink
                className={styles.anchorLink}
                to="/disclaimer"
                onClick={handleLinkClick}
              >
                Security
              </NavLink>
            </p>
            <div>
              <p>
                <NavLink
                  className={styles.anchorLink}
                  to="/disclaimer"
                  onClick={handleLinkClick}
                >
                  Cookie Declaration
                </NavLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
